import { Typography, Box } from "@mui/material";
import { Product } from "../../types/Product";
import {numberFormatter} from "@ecommerce/shared-utils";
import { ProductVariant } from "../../types/ProductVariant";

interface ProductBasicInfoProps {
  product: Product;
  variant?: ProductVariant | null;
}

export default function ProductBasicInfo({ product, variant }: ProductBasicInfoProps) {


  const displayPrice = variant ? variant.precio : product.precio;


  return (
    <Box>
      {/* Product Name */}
      <Typography
        variant="h1"
        sx={{
          fontSize: "40px",
          fontWeight: '700',
          fontFamily: "'Rubik', sans-serif",
          mb: 1,
          textTransform: "uppercase",
          lineHeight: 1.2,
        }}
      >
        {product.nombre}
      </Typography>

      {/* Price */}
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: "22px",
            fontWeight: '700',
            fontFamily: "'Rubik', sans-serif",
            color: "black",
            lineHeight: 1.4,
          }}
        >
          {numberFormatter.toStringWithAmount(displayPrice, '$')}
        </Typography>
        {/*{displayPrice && (*/}
        {/*  <Typography*/}
        {/*    sx={{*/}
        {/*      fontSize: "1rem",*/}
        {/*      textDecoration: "line-through",*/}
        {/*      color: "grey.600",*/}
        {/*      fontFamily: "'Rubik', sans-serif",*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    {numberFormatter.toStringWithAmount(displayPrice, '$')}*/}
        {/*  </Typography>*/}
        {/*)}*/}
      </Box>

      {/* Discount Section */}
      {/*<Box sx={{ mb: 3 }}>
        <Typography
          variant="h5"
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            fontFamily: "'Rubik', sans-serif",
            color: "#dab99a",
            mb: 0.5,
          }}
        >
          10% OFF comprando 1 o más!
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontFamily: "'Rubik', sans-serif",
            lineHeight: "22px",
            color: "#010101",
          }}
        >
          Vas a poder aprovechar esta promoción en cualquier producto de la tienda.
        </Typography>
      </Box>
      */}
    </Box>
  );
}














